// Create and open the modal

function floowOpenModal(content) {
  const modal = document.querySelector(".floow-modal");

  if (!modal) {
    // If theres no modal container, create one and put it at the beginning of the body
    const modalText = `
      <div class="floow-modal">
        <div class="floow-modal-background" onclick="floowCloseModal();"></div>
        <div class="floow-modal-content-container">
          <svg 
            class="floow-modal-close"
            onclick="floowCloseModal()"
            role="presentation" stroke-width="2" focusable="false" width="24" height="24" viewBox="0 0 24 24">
              <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343"></path>
          </svg>
          <div class="floow-modal-content"></div>
        </div>
      </div>  
      `;
    const modalHTML = new DOMParser().parseFromString(modalText, "text/html");
    const modalElement = modalHTML.body.querySelector(".floow-modal");
    document.body.prepend(modalElement);
  }

  // Put the content in the modal
  const modalContent = document.querySelector(".floow-modal-content");
  modalContent.innerHTML = content.innerHTML;

  // Open the modal
  document.querySelector(".floow-modal").setAttribute("open", "");
}

// Close the modal

function floowCloseModal() {
  document.querySelector(".floow-modal").removeAttribute("open");
}

// Money formatting


function floowInitializeSlider(s, id) {
  const sliderWrapper = document.querySelector(`.slider-wrapper-${id}`);
  const slider = document.querySelector(`.slider-${id}`);
  const slides = Array.from(slider.children);
  const left = document.querySelector(`.left-arrow-${id}`);
  const right = document.querySelector(`.right-arrow-${id}`);
  let active = 0, autoSlideTimer = null, pauseTimer = null, isTouching = false;

  const isMobile = () => window.innerWidth <= s.mobile.width;
  const gap = () => isMobile() ? s.mobile.gap : s.gap;
  const spv = () => isMobile() ? s.mobile.slidesPerView : s.slidesPerView;
  const maxActive = () => slides.length - spv();
  const slideWidth = () => (slider.getBoundingClientRect().width - gap() * (spv() - 1)) / spv();

  // INP-Fix: Slide-Breite und Gap werden nur in calc() gelesen und hier
  // zwischengespeichert. getOffset() greift dadurch nie aufs Layout zu.
  let cachedSlideWidth = 0;
  let cachedGap = 0;
  const getOffset = (i) => i * (cachedSlideWidth + cachedGap);

  // INP-Fix: Dots einmal bei der Initialisierung sammeln (siehe showNav unten)
  // statt bei jedem Slide-Wechsel per querySelectorAll den DOM zu durchsuchen.
  let dots = [];

  const scroll = (i) => {
    slider.style.transform = `translateX(-${getOffset(i)}px)`;
    if (s.showNav) {
      dots.forEach((d) => d.classList.toggle("floow-dot-active", d.getAttribute("dot-index") == i));
    }
  };

  const calc = () => {
    // INP-Fix: Layout genau einmal lesen (statt einmal pro Slide in der
    // Schleife), dann nur noch schreiben – entfernt die erzwungenen Reflows.
    const width = slideWidth();
    const g = gap();
    cachedSlideWidth = width;
    cachedGap = g;
    slides.forEach((slide) => (slide.style.width = `${width}px`));
    slider.style.gap = `${g}px`;
    scroll(active);
  };

  calc();

  // INP-Fix: ResizeObserver nur bei geänderter Breite auslösen. Auf Mobile
  // ändert das Ein-/Ausblenden der URL-Leiste beim Scrollen nur die Höhe –
  // die ist für den horizontalen Slider irrelevant. Ausführung im rAF.
  let lastObservedWidth = 0;
  const sliderResizeObserver = new ResizeObserver(([entry]) => {
    const width = Math.round(entry.contentRect.width);
    if (width === lastObservedWidth) return;
    lastObservedWidth = width;
    requestAnimationFrame(calc);
  });
  sliderResizeObserver.observe(slider);

  // Auto-slide state – hoisted here so touch handlers can access it too
  let manuallyStopped = false;
  const start = () => {
    if (!s.autoSlide || autoSlideTimer) return;
    autoSlideTimer = setInterval(() => {
      if (isTouching) return;   // finger still on screen – skip this tick
      active = active < maxActive() ? active + 1 : 0;
      scroll(active);
    }, s.autoSlide);
  };
  const stop = () => { clearInterval(autoSlideTimer); autoSlideTimer = null; };
  const pause = (duration) => {
    stop();
    clearTimeout(pauseTimer);
    pauseTimer = setTimeout(() => { if (!manuallyStopped) start(); }, duration);
  };

  left.addEventListener("click", () => { active = active > 0 ? active - 1 : maxActive(); scroll(active); });
  right.addEventListener("click", () => { active = active < maxActive() ? active + 1 : 0; scroll(active); });

  // Touch / Swipe Controls
  const SWIPE_THRESHOLD = 50;   // min px horizontal movement to trigger a slide
  const DRAG_THRESHOLD = 10;    // px before we decide it's a horizontal drag (not a scroll)

  let touchStartX = 0;
  let touchStartY = 0;
  let touchCurrentX = 0;
  let isDragging = false;
  let isHorizontal = null;      // null = undecided, true = horizontal drag, false = vertical scroll

  // INP-Fix: Offset beim touchstart einmal einfrieren; im touchmove wird nur
  // noch gerechnet und höchstens einmal pro Frame (rAF) geschrieben.
  let touchStartOffset = 0;
  let dragRafPending = false;
  let dragTargetOffset = 0;

  const sliderClip = document.querySelector(`.slider-clip-${id}`);

  sliderClip.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchCurrentX = touchStartX;
    isDragging = false;
    isHorizontal = null;
    isTouching = true;
    touchStartOffset = getOffset(active);   // einmal lesen, nicht pro Move
    slider.style.transition = "none";
    // Stop auto-slide immediately while finger is on the slider
    if (s.autoSlide && !manuallyStopped) stop();
  }, { passive: true });

  sliderClip.addEventListener("touchmove", (e) => {
    const dx = e.touches[0].clientX - touchStartX;
    const dy = e.touches[0].clientY - touchStartY;
    touchCurrentX = e.touches[0].clientX;

    // Decide once: horizontal drag or vertical scroll?
    if (isHorizontal === null && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
      isHorizontal = Math.abs(dx) > Math.abs(dy);
    }

    if (isHorizontal) {
      // passive:false muss bleiben, damit preventDefault() das vertikale
      // Mitscrollen verhindert. Im Handler wird aber kein Layout mehr gelesen
      // und höchstens einmal pro Frame geschrieben.
      e.preventDefault();   // block page scroll while swiping the slider
      isDragging = true;
      dragTargetOffset = touchStartOffset - dx;   // reine Rechnung, kein Layout-Zugriff
      if (dragRafPending) return;
      dragRafPending = true;
      requestAnimationFrame(() => {
        slider.style.transform = `translateX(-${dragTargetOffset}px)`;
        dragRafPending = false;
      });
    }
  }, { passive: false });

  sliderClip.addEventListener("touchend", () => {
    isTouching = false;
    slider.style.transition = "";   // re-enable CSS transition

    const delta = touchCurrentX - touchStartX;

    if (isDragging) {
      if (delta < -SWIPE_THRESHOLD) {
        active = active < maxActive() ? active + 1 : 0;
      } else if (delta > SWIPE_THRESHOLD) {
        active = active > 0 ? active - 1 : maxActive();
      }
      scroll(active);
    }

    // Resume auto-slide after a short pause (whether it was a swipe or just a tap)
    if (s.autoSlide && !manuallyStopped) pause(5000);
  }, { passive: true });

  sliderClip.addEventListener("touchcancel", () => {
    isTouching = false;
    slider.style.transition = "";
    scroll(active);   // snap back to current slide
    if (s.autoSlide && !manuallyStopped) start();
  }, { passive: true });

  if (s.autoSlide) {
    const playIcon = sliderWrapper.querySelector(".floow-slider-play");
    const pauseIcon = sliderWrapper.querySelector(".floow-slider-pause");

    const updateIcons = () => {
      if (!playIcon || !pauseIcon) return;
      playIcon.style.display = manuallyStopped ? "" : "none";
      pauseIcon.style.display = manuallyStopped ? "none" : "";
      pauseIcon.classList.toggle("paused", manuallyStopped);
    };

    if (playIcon) playIcon.addEventListener("click", (e) => { e.stopPropagation(); manuallyStopped = false; start(); updateIcons(); });
    if (pauseIcon) pauseIcon.addEventListener("click", (e) => { e.stopPropagation(); manuallyStopped = true; stop(); clearTimeout(pauseTimer); updateIcons(); });

    sliderWrapper.addEventListener("mouseenter", () => { if (!manuallyStopped) stop(); });
    sliderWrapper.addEventListener("mouseleave", () => { if (!manuallyStopped) start(); });
    sliderWrapper.addEventListener("click", () => { if (!manuallyStopped) pause(5000); });

    updateIcons();
    start();
  }

  if (s.showNav) {
    const navContainer = sliderWrapper.querySelector(".floow-dot-wrapper");
    slides.forEach((_, i) => {
      const e = document.createElement("div");
      e.classList.add("floow-dot");
      if (i === 0) e.classList.add("floow-dot-active");
      e.setAttribute("dot-index", i);
      e.addEventListener("click", () => { active = i; scroll(active); });
      navContainer.appendChild(e);
      dots.push(e);   // INP-Fix: einmal merken statt querySelectorAll pro Slide-Wechsel
    });
  }
}




async function floowChangeVariant(productId, event, atcText, soldOutText) {
  const container = event.target.closest(`.floow-variant-picker-wrapper[product-id="${productId}"]`);
  const productData = JSON.parse(document.getElementById(`product-data-${productId}`).textContent);

  // 1. Gewählte Optionen sammeln
  const selectedOptions = [];
  container.querySelectorAll('.floow-variant-picker-value:checked').forEach((el) => {
    selectedOptions.push(el.value.trim());
  });

  // 2. Passende Variante finden
  const variant = productData.variants.find(v => {
    return v.options.every((opt, i) => opt === selectedOptions[i]);
  });

  if (!variant) {
    console.warn("Keine Variante gefunden für", selectedOptions);
    return;
  }

  // 3. Bild aktualisieren
  const imgEl = container.querySelector('.floow-variant-picker-image');
  if (variant.featured_image) {
    imgEl.src = variant.featured_image.src;
    imgEl.alt = variant.featured_image.alt || '';
  }

  // 4. Preis aktualisieren
  const priceEl = container.querySelector('.floow-variant-picker-price');
  priceEl.textContent = floowFormatMoney(variant.price);

  // Compare-at Preis
  const compareEl = container.querySelector('.floow-variant-picker-compare-at-price');
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    compareEl.style.display = 'inline';
    compareEl.textContent = floowFormatMoney(variant.compare_at_price);
  } else {
    compareEl.style.display = 'none';
  }

  // 5. Add-to-Cart Button aktualisieren
  const atc = container.querySelector('.floow-variant-picker-atc');
  if (variant.available) {
    atc.classList.remove('floow-variant-picker-disabled');
    atc.innerText = atcText;
    atc.onclick = () => {
      floowAddToCart(variant.id, 1, atc);
      floowCloseModal();
      floowOpenCart();
    };
  } else {
    atc.classList.add('floow-variant-picker-disabled');
    atc.innerText = soldOutText;
    atc.onclick = null;
  }

 productData.options.forEach((optionName, optionIndex) => {
  const optionPos = optionIndex + 1; // Shopify Position = 1-basiert

  const allValues = [...new Set(productData.variants.map(v => v.options[optionIndex]))];

  allValues.forEach(value => {
    const input = container.querySelector(
      `.floow-variant-radio-${optionPos}[value="${CSS.escape(value)}"]`
    );
    if (!input) return;

    const possibleVariant = productData.variants.find(v => {
      return v.options[optionIndex] === value &&
             v.options.every((opt, i) => i === optionIndex || opt === selectedOptions[i]) &&
             v.available;
    });

    if (possibleVariant) {
  input.closest('label').classList.remove('floow-variant-picker-disabled');
} else {
  input.closest('label').classList.add('floow-variant-picker-disabled');
}

  });
});

}

async function floowRequestSection(string) { 
  const url = `${window.location.origin}/${string}`;
  const response = await fetch(url);
  const htmlString = await response.text();
  const html = new DOMParser().parseFromString(htmlString, "text/html");
  return html;
}


async function floowAddToCart(id, quantity) {

  const formData = {
    items: [
      {
        id: id,
        quantity: quantity
      }
    ]
  };

  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  const data = await response.json();
}

function floowWaitForElement(selector) {
  return new Promise((resolve) => {

    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);

      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}